export default "__VITE_ASSET__I8He_0ra__"